import { styled, mobile } from '@obvio/app'
import { Section } from '@obvio/ui'

export const Layout = styled.div`
  padding-top: ${(theme) => theme.spacing.medium};

  @media ${mobile} {
    min-height: 34rem;
  }
`

export const SignSection = styled(Section)`
  padding-top: 0 !important;
  grid-column: 2 / span 7;
  width: 100%;
  max-width: 76rem;
  @media ${mobile} {
    max-width: calc(100vw - ${(theme) => theme.spacing.medium});
  }
`

export const SingleSection = styled.div<{ $content?: boolean }>`
  flex: 1;
  margin: ${(_theme, { $content }) => ($content ? 'auto' : 'unset')};
  margin-top: ${(theme, { $content }) =>
    $content ? 'auto' : theme.spacing.small};
  max-width: ${(_theme, { $content }) => ($content ? '29.5rem' : 'unset')};
  width: 100%;
  position: relative;
`

export const ImageSection = styled(SingleSection)`
  display: flex;
  justify-content: left;
  @media ${mobile} {
    display: none;
  }
`
